import { render, staticRenderFns } from "./ReportGeneralStatistics.vue?vue&type=template&id=65e1e4c6&scoped=true&"
import script from "./ReportGeneralStatistics.vue?vue&type=script&lang=js&"
export * from "./ReportGeneralStatistics.vue?vue&type=script&lang=js&"
import style0 from "./ReportGeneralStatistics.vue?vue&type=style&index=0&id=65e1e4c6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e1e4c6",
  null
  
)

export default component.exports